import { render, staticRenderFns } from "./GridRowGroup.vue?vue&type=template&id=b8851c0e&"
import script from "./GridRowGroup.vue?vue&type=script&lang=js&"
export * from "./GridRowGroup.vue?vue&type=script&lang=js&"
import style0 from "./GridRowGroup.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports